import * as React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import '../../../App.css'
import '../../../css/modal.scss'
import '../../../css/common.scss'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import {
  Box,
  Button,
  Grid,
  Modal as MuiModal,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { getBranchList, updateAlert, updateBrnchList, updateStrtBrnch } from '../../../store/common/common_action'
import { getValidationMessages } from '../../../i18n/validationMessages'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontNirmalaNormal } from '../BranchTransfer/fonts/Nirmala-normal'
import { callAddFontNirmalaBold } from '../BranchTransfer/fonts/Nirmala-bold'
import { Item } from '../../common/snippets'
import Datepicker from '../../common/datePicker'
import {
  ReceivedItem_ChallanNo,
  ReceivedItem_Consignment_Type,
  ReceivedItem_Payment_Type,
  ReceivedItem_vehicleNo,
  Received_To_Branch,
  Received_To_City,
  Received_Transfer_From_Branch,
  Received_Transfer_From_City,
  Transfer_Type,
} from './Lables'
import DropDownOA from '../../common/dropDownOA'
import DropDown from '../../common/dropDown'
import { From_Date, To_Date} from '../BranchTransfer/Lables'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { getUpdateReceiveItemList } from '../../../store/branchTransferReceive/branchReceive_action'
import { clickElement, formatDate, formatDate2, isEmpty } from '../../common/helper'
import { API_CACHE_DURATION, branchObj } from '../../common/constants'
import { useTranslation } from '../../../i18n/I18nProvider'

const ReceivedItem = ({ data, getBranchList, updateBrnchList,  getUpdateReceiveItemList, handleAlert }) => {
  const { translations } = useTranslation()
  const btr = translations.branchTransferReceive || {}
  const cs = translations.common || {}
  const error = getValidationMessages(translations)
  const { common, BranchTransferReceiveReducer } = data
  const { receiveItemList } = { ...BranchTransferReceiveReducer }
  const { strtCity, strtBrnch, loginData, cityList, brnchList, destBrnchList, alert } = { ...common }


  const [searchResult, setSearchResult] = useState(false)
  const [state, setState] = useState({
    filter: false,
    generatePDF: false,
    load: false,
    buttonsShow: false,
  })
  const { filter, generatePDF, load, buttonsShow } = { ...state }
  const [date, setDate] = useState({
    fromDate: null,
    toDate: null,
  })
  const { fromDate, toDate, fromMonths,
    toMonths} = { ...date }
  const [receivedState, setReceivedState] = useState({
    fromCity: '',
    toCity: false,
    fromBranch: 'All',
    toBranch: '',
    fromDate: '',
    toDate: '',
    TransferType: [],
    PaymentType: [],
    VehicleNo: [],
    ItemType: [],
    VoucherNo: [],
    TransferTypeState: '',
    PaymentTypeState: '',
    VehicleNoState: '',
    ItemTypeState: '',
    VoucherNoState: '',
  })
  const {
    fromCity,
    fromBranch,
    toBranch,
    toCity,
    PaymentType,
    VehicleNo,
    ItemType,
    VoucherNo,
    TransferType,
    TransferTypeState,
    PaymentTypeState,
    VehicleNoState,
    ItemTypeState,
    VoucherNoState,
  } = { ...receivedState }
  const [tableData, setTableData] = useState([])
  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }

//compare betwween two dates of months
function diffInMonths(from, to){
  var months = to.getMonth() - from.getMonth() + (12 * (to.getFullYear() - from.getFullYear()));

  if(to.getDate() < from.getDate()){
      var newFrom = new Date(to.getFullYear(),to.getMonth(),from.getDate());
      if (to < newFrom  && to.getMonth() == newFrom.getMonth() && to.getYear() %4 != 0){
          months--;
      }
  }

  return months;
}

  const GroupData = (array) => {
    if(array.length>=1){
    var newData = {}
    array?.forEach((item) => {
      if (!(item['TransferType'] in newData)) {
        newData[item['TransferType']] = []
      }
      newData[item['TransferType']].push({
        AllCartage: item['AllCartage'],
        AllHamali: item['AllHamali'],
        BookingID: item['BookingID'],
        Description: item['Description'],
        DestinationBranch: item['DestinationBranch'],
        DestinationCity: item['DestinationCity'],
        Freight: item['Freight'],
        ItemType: item['ItemType'],
        LRNO: item['LRNO'],
        NOP: item['NOP'],
        NetAmount: item['NetAmount'],
        OtherChg: item['OtherChg'],
        PaymentType: item['PaymentType'],
        RecAddress: item['RecAddress'],
        RecMobileNo: item['RecMobileNo'],
        RecName: item['RecName'],
        ReceiptDate: item['ReceiptDate'],
        TransferDate: item['TransferDate'],
        ReceiveBranch: item['ReceiveBranch'],
        ReceiverEmailID: item['ReceiverEmailID'],
        ReceiverGSTN: item['ReceiverGSTN'],
        Remarks: item['Remarks'],
        Sender: item['Sender'],
        SenderAddress: item['SenderAddress'],
        SenderEmailID: item['SenderEmailID'],
        SenderGSTN: item['SenderGSTN'],
        SenderMobileNo: item['SenderMobileNo'],
        SendingBranch: item['SendingBranch'],
        ServiceTaxAmount: item['ServiceTaxAmount'],
        SourceBranch: item['SourceBranch'],
        SourceCity: item['SourceCity'],
        TransferType: item['TransferType'],
        Valuation: item['Valuation'],
        VehicleNo: item['VehicleNo'],
        VoucherNo: item['VoucherNo'],
      })
    })

    const secondGrop = {}
    const ThirdGrop = {}
    Object.keys(newData)?.forEach((item) => {
      if (item === 'Booking Transfer') {
        newData[item]?.forEach((val) => {
          if (!(val['DestinationBranch'] in secondGrop)) {
            secondGrop[val['DestinationBranch']] = []
          }
          secondGrop[val['DestinationBranch']].push({
            transferType: item,
            AllCartage: val['AllCartage'],
            AllHamali: val['AllHamali'],
            BookingID: val['BookingID'],
            Description: val['Description'],
            DestinationCity: val['DestinationCity'],
            Freight: val['Freight'],
            ItemType: val['ItemType'],
            LRNO: val['LRNO'],
            NOP: val['NOP'],
            NetAmount: val['NetAmount'],
            OtherChg: val['OtherChg'],
            PaymentType: val['PaymentType'],
            RecAddress: val['RecAddress'],
            RecMobileNo: val['RecMobileNo'],
            RecName: val['RecName'],
            ReceiptDate: val['ReceiptDate'],
            ReceiveBranch: val['ReceiveBranch'],
            ReceiverEmailID: val['ReceiverEmailID'],
            ReceiverGSTN: val['ReceiverGSTN'],
            Remarks: val['Remarks'],
            Sender: val['Sender'],
            SenderAddress: val['SenderAddress'],
            SenderEmailID: val['SenderEmailID'],
            SenderGSTN: val['SenderGSTN'],
            SenderMobileNo: val['SenderMobileNo'],
            SendingBranch: val['SendingBranch'],
            ServiceTaxAmount: val['ServiceTaxAmount'],
            SourceBranch: val['SourceBranch'],
            SourceCity: val['SourceCity'],
            TransferType: val['TransferType'],
            Valuation: val['Valuation'],
            VehicleNo: val['VehicleNo'],
            VoucherNo: val['VoucherNo'],
            TransferDate: val['TransferDate'],
          })
        })
      } else {
        newData[item]?.forEach((val) => {
          if (!(val['SourceBranch'] in ThirdGrop)) {
            ThirdGrop[val['SourceBranch']] = []
          }
          ThirdGrop[val['SourceBranch']].push({
            transferType: item,
            AllCartage: val['AllCartage'],
            AllHamali: val['AllHamali'],
            BookingID: val['BookingID'],
            Description: val['Description'],
            DestinationCity: val['DestinationCity'],
            Freight: val['Freight'],
            ItemType: val['ItemType'],
            LRNO: val['LRNO'],
            NOP: val['NOP'],
            NetAmount: val['NetAmount'],
            OtherChg: val['OtherChg'],
            PaymentType: val['PaymentType'],
            RecAddress: val['RecAddress'],
            RecMobileNo: val['RecMobileNo'],
            RecName: val['RecName'],
            ReceiptDate: val['ReceiptDate'],
            ReceiveBranch: val['ReceiveBranch'],
            ReceiverEmailID: val['ReceiverEmailID'],
            ReceiverGSTN: val['ReceiverGSTN'],
            Remarks: val['Remarks'],
            Sender: val['Sender'],
            SenderAddress: val['SenderAddress'],
            SenderEmailID: val['SenderEmailID'],
            SenderGSTN: val['SenderGSTN'],
            SenderMobileNo: val['SenderMobileNo'],
            SendingBranch: val['SendingBranch'],
            ServiceTaxAmount: val['ServiceTaxAmount'],
            DestinationBranch: val['DestinationBranch'],
            SourceCity: val['SourceCity'],
            TransferType: val['TransferType'],
            Valuation: val['Valuation'],
            VehicleNo: val['VehicleNo'],
            VoucherNo: val['VoucherNo'],
            TransferDate: val['TransferDate'],
          })
        })
      }
    })
    let quantityTotal = 0
    let actualweightTotal = 0
    let NetAmountTotal = 0
    let city = ''
    Object.keys(secondGrop)?.map((val) => {
      secondGrop[val].forEach((val) => {
        quantityTotal += Number(val.NOP)
        NetAmountTotal += Number(val.NetAmount)
      })
      secondGrop[val]?.push({
        srNo: val + ` Total`,
        NOP: quantityTotal.toFixed(2),
        NetAmount: NetAmountTotal.toFixed(2),
        gross: NetAmountTotal,
      })
      secondGrop[val]?.push({
        srNo: secondGrop[val][0].DestinationCity + ` Total`,
        NOP: quantityTotal.toFixed(2),
        NetAmount: NetAmountTotal.toFixed(2),
        gross: NetAmountTotal,
      })
      city = secondGrop[val][0].ToCity
      secondGrop[val]?.unshift({
        srNo: 'TransferType: ' + secondGrop[val][0].TransferType,
        ReceiveBranch: `Destination City : ` + secondGrop[val][0].DestinationCity,
        VehicleNo: `Destination Branch : ` + val,
      })
      quantityTotal = 0
      actualweightTotal = 0
      NetAmountTotal = 0
    })
    Object.keys(ThirdGrop)?.map((val) => {
      ThirdGrop[val].forEach((val) => {
        quantityTotal += Number(val.NOP)
        NetAmountTotal += Number(val.NetAmount)
      })
      ThirdGrop[val]?.push({
        srNo: val + ` Total`,
        NOP: quantityTotal.toFixed(2),
        NetAmount: NetAmountTotal.toFixed(2),
        gross: NetAmountTotal,
      })
      ThirdGrop[val]?.push({
        srNo: ThirdGrop[val]?.[0].SourceCity + ` Total`,
        NOP: quantityTotal.toFixed(2),
        NetAmount: NetAmountTotal.toFixed(2),
        gross: NetAmountTotal,
      })
      city = ThirdGrop[val][0].ToCity
      ThirdGrop[val]?.unshift({
        srNo: 'TransferType: ' + ThirdGrop[val][0].TransferType,
        RecName: `Source City : ` + ThirdGrop[val][0].SourceCity,
        VehicleNo: `Source Branch : ` + val,
      })
      quantityTotal = 0
      actualweightTotal = 0
      NetAmountTotal = 0
    })
    Object.keys(secondGrop).forEach((item,i)=>{
      secondGrop[item]?.forEach((val,i)=>{
        if(Object.keys(val).length>=5){
          val.srNo = (i + 1)-1
        }
      })
    })
    Object.keys(ThirdGrop).forEach((item,i)=>{
      ThirdGrop[item]?.forEach((val,i)=>{
        if(Object.keys(val).length>=5){
          val.srNo = (i + 1)-1
        }
      })
    })
    const mainData = { ...secondGrop, ...ThirdGrop }
    let bodyData = []
    Object.keys(mainData)?.map((item) => {
      const data = [...bodyData]
      bodyData = [...data, ...mainData[item]]
    })
  
    setTableData(bodyData)
    } else{
    setTableData([])

    }
  }



 
  useEffect(() => {
    if (receiveItemList.status == 'Success') {
      if (receiveItemList?.Data?.Table?.length >= 1) {
        const PaymentType = [...new Set(receiveItemList?.Data?.Table?.map((val) => val.PaymentType))]
        const ItemType = [...new Set(receiveItemList?.Data?.Table?.map((val) => val.ItemType))]
        const VehicleNo = [...new Set(receiveItemList?.Data?.Table?.map((val) => val.VehicleNo))]
        const VoucherNo = [...new Set(receiveItemList?.Data?.Table?.map((val) => val.VoucherNo))]
        setReceivedState({
          ...receivedState,
          PaymentType: PaymentType,
          VehicleNo: VehicleNo,
          ItemType: ItemType,
          VoucherNo: VoucherNo,
          TransferType: ['Booking Transfer', 'Delivery Transfer'],
        })
        GroupData(receiveItemList?.Data?.Table)
      } else {
        setTableData([])
        setReceivedState({ ...receivedState, PaymentType: [], VehicleNo: [], ItemType: [], VoucherNo: [], TransferType: [] })
      }
    }
  }, [receiveItemList?.Data?.Table])

  useEffect(() => {
    const todayDate = new Date().toString().split(' ')
    const year = todayDate[3]
    const day = todayDate[2]
    const month = getNumericMonth(todayDate[1])
    const currentDate = `${year}-${month}-${day}`
    const today = `${day}-${month}-${year}`
    setDate({ ...date, fromDate: currentDate, toDate: currentDate })
  }, [])

  useEffect(() => {
  if(!isEmpty(loginData)){
    if (strtCity?.CityID) {
      setReceivedState({ ...receivedState, fromCity: strtCity })

      getBranchList(loginData, strtCity?.CityID, 2, true, API_CACHE_DURATION)
      // updateStrtBrnch(brnchList.find(({ BranchID }) => BranchID == loginData.intBranchID) || {})
      updateBrnchList(brnchList, 1)
      // setReceivedState({...receivedState,fromCity:{CityName:strtCity.CityName}})
    }
  }
  }, [loginData])

  useEffect(() => {
    if(fromCity!==""){
      getBranchList(loginData, fromCity?.CityID, 2, true, API_CACHE_DURATION)
    }
  }, [fromCity?.CityID])
//All use Effect End
  const handleChange = (e, id) => {
    switch (id) {
      case 'transferfromdate':
        const Fromdate = e?._d?.toString()?.split(' ')
        const fromyear = Fromdate?.[3]
        const fromday = Fromdate?.[2]
        const frommonth = getNumericMonth(e?._d?.toString()?.split(' ')?.[1])
        const fromcurrentDate = `${fromyear}-${frommonth}-${fromday}`
        setDate({ ...date, fromDate: fromcurrentDate })
        break
      case 'transferTodate':
        const Todate = e?._d?.toString()?.split(' ')
        const year = Todate?.[3]
        const day = Todate?.[2]
        const month = getNumericMonth(e?._d?.toString()?.split(' ')?.[1])
        const currentDate = `${year}-${month}-${day}`
        setDate({ ...date, toDate: currentDate })
        break
      default:
        break
    }
  }

  const printClick = () => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontNirmalaBold])
    jsPDF.API.events.push(['addFonts', callAddFontNirmalaNormal])

    const HeaderColumn = [
      {
        headerName: cs.fromDate,
        exportHead: cs.fromDate,
        field: 'FromDate',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: cs.toDate,
        exportHead: cs.toDate,
        field: 'ToDate',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: btr.transferFromCity,
        exportHead: btr.transferFromCity,
        field: 'TransferFromCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: btr.transferFromBranch,
        exportHead: btr.transferFromBranch,
        field: 'TransferFromBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: btr.receivedToCity,
        exportHead: btr.receivedToCity,
        field: 'ReceivedToCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: btr.receivedToBranch,
        exportHead: btr.receivedToBranch,
        field: 'ReceivedToBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]

    const columnDefs = [
      {
        headerName: btr.srNo,
        exportHead: btr.sn,
        field: 'srNo',
        xlCol: { dataType: 'number', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.lrNo,
        exportHead: btr.lrNo,
        field: 'LRNO',
        xlCol: { dataType: 'string', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.transferDate,
        exportHead: btr.transferDate,
        field: 'TransferDate',
        xlCol: { dataType: 'string', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.receivedDate,
        exportHead: btr.receivedDate,
        field: 'ReceiptDate',
        xlCol: { dataType: 'string', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.transferByBranch,
        exportHead: btr.transferByBranch,
        field: 'SendingBranch',
        xlCol: { dataType: 'quantity', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.receivedByBranch,
        exportHead: btr.receivedByBranch,
        field: 'ReceiveBranch',
        xlCol: { dataType: 'quantity', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.senderName,
        exportHead: btr.senderName,
        field: 'Sender',
        xlCol: { dataType: 'string', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.receiverName,
        exportHead: btr.receiverName,
        field: 'RecName',
        xlCol: { dataType: 'string', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: cs.vehicleNo,
        exportHead: cs.vehicleNo,
        field: 'VehicleNo',
        xlCol: { dataType: 'quantity', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.challanNo,
        exportHead: btr.challanNo,
        field: 'VoucherNo',
        xlCol: { dataType: 'quantity', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: cs.paymentType,
        exportHead: cs.paymentType,
        field: 'PaymentType',
        xlCol: { dataType: 'quantity', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: cs.consignmentType,
        exportHead: cs.consignmentType,
        field: 'ItemType',
        xlCol: { dataType: 'quantity', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.units,
        exportHead: btr.units,
        field: 'NOP',
        xlCol: { dataType: 'quantity', dataFormatter: null,fontSize:5 },
      },
      {
        headerName: btr.grossAmount,
        exportHead: btr.grossAmount,
        field: 'NetAmount',
        xlCol: { dataType: 'string', dataFormatter: null,fontSize:5,halign:"left" },
      },
    ]

    const pdfColumns = columnDefs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderData = [
      {
        FromDate: formatDate2(fromDate),
        ToDate: formatDate2(toDate),
        TransferFromCity: fromCity?.CityName,
        TransferFromBranch: fromBranch == 'All' ? 'Multiple Branches' : fromBranch.BranchName,
        ReceivedToCity: fromCity?.CityName,
        ReceivedToBranch:loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? toBranch.BranchName:strtBrnch.BranchName,
      },
    ]
    const doc = new jsPDF()

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'left', fillColor: [30, 89, 167] },
    })

    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc

      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
      doc.setDrawColor(0, 0, 0)
      doc.setLineWidth(0.2)
      doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7)
      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(9)
      doc.text(str, 5 + 260, pageHeight - 2)
      doc.setFont('Nirmala', 'normal')
      doc.text(`${btr.reportBy} : ${userData.strUserName} [ ${userData.strBranchName} ]`, 5, pageHeight - 2)
      doc.text(`${btr.reportTime} : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, 5 + 150, pageHeight - 2)
    }

    let drawCell = function (data) {
      var rows = data.table.body
      rows.map((val) => {
        if (Object.keys(val.raw).length == 3) {
          val.cells[0].colSpan = 5
          val.cells[0].styles.font = 'Nirmala'
          val.cells[0].styles.fontStyle = 'bold'
          val.cells[0].styles.fontSize = '7'
          val.cells[0].styles.halign = 'left'
          val.cells[0].styles.fillColor = [245, 250, 254]

          val.cells[5].colSpan = 3
          val.cells[5].styles.font = 'Nirmala'
          val.cells[5].styles.fontStyle = 'bold'
          val.cells[5].styles.fontSize = '7'
          val.cells[5].styles.fillColor = [245, 250, 254]

          val.cells[8].colSpan = 6
          val.cells[8].styles.font = 'Nirmala'
          val.cells[8].styles.fontStyle = 'bold'
          val.cells[8].styles.fontSize = '7'
          val.cells[8].styles.fillColor = [245, 250, 254]
        }
        if (Object.keys(val.raw).length == 4) {

          val.cells[0].colSpan = 12
          val.cells[0].styles.font = 'Nirmala'
          val.cells[0].styles.fontStyle = 'bold'
          val.cells[0].styles.fontSize = '7'
          val.cells[0].styles.halign = 'right'
          val.cells[0].styles.fillColor = [208, 220, 238]

          val.cells[12].colSpan = 1
          val.cells[12].styles.font = 'Nirmala'
          val.cells[12].styles.fontStyle = 'bold'
          val.cells[12].styles.fontSize = '7'
          val.cells[12].styles.halign = 'right'
          val.cells[13].styles.minCellWidth = 10
          val.cells[12].styles.fillColor = [208, 220, 238]

          val.cells[13].colSpan = 1
          val.cells[13].styles.font = 'Nirmala'
          val.cells[13].styles.fontStyle = 'bold'
          val.cells[13].styles.fontSize = '7'
          val.cells[13].styles.halign = 'right'
          val.cells[13].styles.minCellWidth = 13
          val.cells[13].styles.fillColor = [208, 220, 238]
        }
      })
    }

    doc.setProperties({
      title: `${btr.itemList}.pdf`,
      subject: `${btr.receiveSummaryReport}`,
      author: btr.mavenTechLabsPvtLtd,
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 19, left: 5, right: 5, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { halign: 'left', font: 'Nirmala', fontSize: 7, fontStyle: 'bold' },
        1: { fontSize: 7, font: 'Nirmala', halign: 'left', fontStyle: 'bold' },
        2: { fontSize: 7, font: 'Nirmala', halign: 'left', fontStyle: 'bold' },
        3: { fontSize: 7, font: 'Nirmala', halign: 'left', fontStyle: 'bold' },
        4: { fontSize: 7, font: 'Nirmala', halign: 'left', fontStyle: 'bold' },
        5: { fontSize: 7, font: 'Nirmala', halign: 'left', fontStyle: 'bold' },
        6: { fontSize: 7, font: 'Nirmala', halign: 'left', fontStyle: 'bold' },
      },
      theme: 'grid',
      headStyles: {
        fontSize: 7,
        fontStyle: 'bold',
        fillColor: [30, 89, 167],
      },
    })

    autoTable(doc, {
      margin: { top: 20, left: 5, right: 5, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfColumns,
      body: tableData,
      columnStyles: {
        0: { halign: 'right', fontSize: 7, fontStyle: 'bold', minCellWidth: 8 },
        1: { fontSize: 7, font: 'Nirmala', fontStyle: 'bold', minCellWidth: 10 },
        2: { fontSize: 7, font: 'Nirmala', minCellWidth: 15, fontStyle: 'bold' },
        3: { fontSize: 7, font: 'Nirmala', minCellWidth: 15, fontStyle: 'bold' },
        4: { fontSize: 7, font: 'Nirmala', minCellWidth: 20, fontStyle: 'bold' },
        5: { fontSize: 7, font: 'Nirmala', minCellWidth: 23, fontStyle: 'bold' },
        6: { fontSize: 7, font: 'Nirmala', fontStyle: 'bold', minCellWidth: 12 },
        7: { fontSize: 7, font: 'Nirmala', fontStyle: 'bold', minCellWidth: 14 },
        8: { fontSize: 7, font: 'Nirmala', fontStyle: 'bold', minCellWidth: 10 },
        9: { halign: 'right', fontSize: 7, fontStyle: 'bold', minCellWidth: 13 },
        10: { fontSize: 7, font: 'Nirmala', fontStyle: 'bold', minCellWidth: 12 },
        11: { fontSize: 7, font: 'Nirmala', fontStyle: 'bold', minCellWidth: 11 },
        12: { halign: 'right', fontSize: 7, fontStyle: 'bold', minCellWidth: 10 },
        13: { halign: 'right', fontSize: 7, fontStyle: 'bold', minCellWidth: 10 },
        14: { halign: 'right', fontSize: 7, fontStyle: 'bold', minCellWidth: 10 },
      },
      theme: 'grid',
      headStyles: {
        fontSize:7,
        fontStyle: 'bold',
        fillColor: [30, 89, 167],
      },
      didParseCell: (data) => {
        drawCell(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 5, 8, 8, 8)
        doc.setFontSize(10)
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System', 17, 14)
        doc.setDrawColor(16, 79, 162)
        doc.setLineWidth(0.4)
        doc.line(42, 11, 42, 15)

        doc.setFontSize(10)
        doc.setTextColor(16, 79, 162)
        doc.text(` Received Item List Report`, 44, 14)

        doc.setFontSize(10).setFont(undefined, 'bold')
        doc.setTextColor(0, 0, 0)
        doc.text('Company Name : ', 130, 14)
        doc.setFontSize(9).setFont(undefined, 'normal')
        doc.text(loginData?.strCompanyName, 160, 14)
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Nirmala')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      document.getElementById('output').data = doc.output('datauristring', 'Item List.pdf')
    }, 2000)
  }

  const onClick = (id) => {
    switch (id) {
      case 'Search':
        var g1 = new Date(fromDate);
        var g2 = new Date(toDate);
        if(diffInMonths(g1,g2)!==0){
          handleAlert(cs.cannotSelectMoreThanOneMonth)
        } else{
        if (g1.getTime() <= g2.getTime()){
        // if()
        if (loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1) {
          if (toBranch === '') {
            handleAlert(error.SELECT_RECEIVE_TO_Branch)
          } else {
            setSearchResult(true)

            setState({ ...state, buttonsShow: true })
            const obj = {
              intSendingBranchID: fromBranch == 'All' ? 0 : fromBranch.BranchID,
              intReceivedBranchID: toBranch.BranchID,
              DateFrom: fromDate,
              DateTo: toDate,
            }
            getUpdateReceiveItemList(loginData, obj)
          }
        } else {
          setSearchResult(true)

          setState({ ...state, buttonsShow: true })
          const obj = {
            intSendingBranchID: fromBranch == 'All' ? 0 : fromBranch.BranchID,
            intReceivedBranchID: strtBrnch?.BranchID,
            DateFrom: fromDate,
            DateTo: toDate,
          }
          getUpdateReceiveItemList(loginData, obj)
        }
      } else{
        handleAlert(btr.correctYourSelectedDate)
      }
       }
      
        break
      case 'ExportPDF':
        // setState({...state,load:false})
        setSearchResult(false)
        printClick()
        break
      case 'PrintPDF':
        // setState({...state,load:false})
        setSearchResult(false)
        printClick()
        break
      case 'Back':
        const data = document.getElementById('output')
        data.innerHTML = ''
        setState({ ...state, load: false })
        setSearchResult(true)
        break
      case 'ResetBTN':
        if (TransferTypeState !== '') {
          clickElement('ReceivedTransferType')
        }
        if (PaymentTypeState !== '') {
          clickElement('ReceivedPaymentType')
        }
        if (VehicleNoState !== '') {
          clickElement('ReceivedVehicleNo')
        }
        if (ItemTypeState !== '') {
          clickElement('ReceivedConsignmentType')
        }
        if (VoucherNoState !== '') {
          clickElement('ReceivedChallanNo')
        }
        setReceivedState({
          ...receivedState,
          TransferTypeState: '',
          PaymentTypeState: '',
          VehicleNoState: '',
          ItemTypeState: '',
          VoucherNoState: '',
        })
        GroupData(receiveItemList?.Data?.Table)
        break
      case "Filterbtn":
        if(receiveItemList?.Data?.Table?.length>=1){
          const copyData=[...receiveItemList?.Data?.Table]
          const data = copyData?.filter((item)=> 
            (PaymentTypeState ? item.PaymentType===PaymentTypeState : item.PaymentType!==PaymentTypeState ) &&
            (VoucherNoState ? item.VoucherNo===VoucherNoState : item.VoucherNo!==VoucherNoState) &&
            (TransferTypeState ? item.TransferType===TransferTypeState : item.TransferType!==TransferTypeState) &&
            (VehicleNoState ? item.VehicleNo===VehicleNoState : item.VehicleNo!==VehicleNoState) &&
            (ItemTypeState ? item.ItemType===ItemTypeState : item.ItemType!==ItemTypeState)
          )
          GroupData(data)
        }
        break
      default:
        break
    }
  }

  const InsideRowContent = ({ item, index }) => {
    return (
      <>
        <TableRow className="receivedTr" key={index}>
          {Object.keys(item).length == 3 ? (
            <>
              <TableCell className="receivedTD" style={{ fontWeight: 'bold', background: 'F5FAFE' }} colSpan={5}>
                {item.srNo}
              </TableCell> 
             <TableCell className="receivedTD" style={{ fontWeight: 'bold', background: 'F5FAFE' }} colSpan={3}>
                {item.RecName}
              </TableCell>
              <TableCell className="receivedTD" style={{ fontWeight: 'bold', background: 'F5FAFE' }} colSpan={6}>
                {item.VehicleNo}
              </TableCell>
            </>
          ) : Object.keys(item).length == 4 ? (
            <>
              
              <TableCell
                className="receivedTD"
                style={{ fontWeight: 'bold', background: 'rgb(208, 220, 238)', textAlign: 'right' }}
                colSpan={12}
              >
                {item.srNo}
              </TableCell>
              <TableCell
                className="receivedTD"
                style={{ fontWeight: 'bold', background: 'rgb(208, 220, 238)', textAlign: 'right' }}
                colSpan={1}
              >
                {item.NOP}
              </TableCell>
              <TableCell
                className="receivedTD"
                style={{ fontWeight: 'bold', background: 'rgb(208, 220, 238)', textAlign: 'right' }}
                colSpan={1}
              >
                {item.NetAmount}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell className="receivedTD">{item.srNo}</TableCell>
              <TableCell className="receivedTD">{item.LRNO}</TableCell>
              <TableCell className="receivedTD">{item.TransferDate}</TableCell>
              <TableCell className="receivedTD">{item.ReceiptDate}</TableCell>
              <TableCell className="receivedTD">{item.Sender}</TableCell>
              <TableCell className="receivedTD">{item.RecName}</TableCell>
              <TableCell className="receivedTD">{item.SendingBranch}</TableCell>
              <TableCell className="receivedTD">{item.ReceiveBranch}</TableCell>
              <TableCell className="receivedTD">{item.VehicleNo}</TableCell>
              <TableCell className="receivedTD">{item.VoucherNo}</TableCell>
              <TableCell className="receivedTD">{item.PaymentType}</TableCell>
              <TableCell className="receivedTD">{item.ItemType}</TableCell>
              <TableCell className="receivedTD" style={{ textAlign: 'right' }}>
                {item.NOP}
              </TableCell>
              <TableCell className="receivedTD" style={{ textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }

  return (
    <>
      <Stack className="cancelTransferHeader" sx={{ height: 590 }}>
        <Grid container sx={{ background: '#e1f2fe' }}>
          <Grid item xs={6} md={3}>
            <Item sx={{ background: '#e1f2fe', width: '100%', display: 'flex' }}>
              <Box style={{ width: '50%', marginRight: '14px' }}>
                <div className="input--container date-picker" style={{ width: '100%' }}>
                  <Datepicker
                    className="deliver-date-picker"
                    name={'filter_from_dt'}
                    type="filter_from_dt"
                    // statusChecked={true}
                    dateChange={(date) => {
                      handleChange(date, 'transferfromdate')
                    }}
                    label={cs.fromDate}
                    disabled={false}
                    // star={true}
                  />
                </div>
              </Box>
              <Box style={{ width: '50%' }}>
                <div className="input--container date-picker" style={{ width: '100%' }}>
                  <Datepicker
                    className="deliver-date-picker"
                    name={'filter_from_dt'}
                    type="filter_from_dt"
                    // statusChecked={true}
                    dateChange={(date) => {
                      handleChange(date, 'transferTodate')
                    }}
                    label={cs.toDate}
                    disabled={false}
                    // star={true}
                  />
                </div>
              </Box>
            </Item>
          </Grid>

          <Grid item xs={6} md={3}>
            <Item sx={{ background: '#e1f2fe', display: 'flex' }}>
              <Box style={{ width: '50%', marginRight: '13px' }}>
                <DropDownOA
                  type={Received_Transfer_From_City}
                  defaultvalue={strtCity?.CityName}
                  data={cityList || []}
                  width="100%"
                  searchPlaceholder={btr.searchCityName}
                  label={btr.transferFromCity}
                  disabled={loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? false : true}
                  tabIndex="2"
                  typeOf={1}
                  isObjArr={true}
                  dataKey={`CityName`}
                  idKey={`CityID`}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                  listWidth={"200px"}
                />
              </Box>
              <Box style={{ width: '50%', marginLeft: '3px' }}>
                <DropDownOA 
                  type={Received_Transfer_From_Branch}
                  label={btr.transferFromBranch}
                  data={toCity == true ? [branchObj,...destBrnchList] || [] : [branchObj,...brnchList]}
                  width="100%"
                  searchPlaceholder={btr.searchBranchName}
                  isObjArr={true}
                  dataKey={`BranchName`}
                  idKey={`BranchID`}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                  defaultvalue={'All'}
                  listWidth={"250px"}
                />
              </Box>
            </Item>
          </Grid>
          <Grid item xs={6} md={2}>
            <Item sx={{ background: '#e1f2fe' }}>
              <DropDownOA
                type={Received_To_City}
                defaultvalue={toCity ? fromCity?.CityName || '' : strtCity.CityName}
                width="100%"
                searchPlaceholder={btr.searchCityName}
                label={btr.receivedToCity}
                disabled
                tabIndex="2"
              />
            </Item>
          </Grid>
          <Grid item xs={6} md={2}>
            <Item sx={{ background: '#e1f2fe' }}>
              <DropDownOA
                type={Received_To_Branch}
                data={toCity == true ? destBrnchList || [] : brnchList}
                defaultvalue={
                  loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? '' : strtBrnch.BranchName
                }
                width="100%"
                searchPlaceholder={btr.searchBranchName}
                label={btr.receivingBranch}
                disabled={loginData.IsAdmin == 1 || loginData.IsBranchAdmin == 1 || loginData.IsMTPLAdmin == 1 ? false : true}
                tabIndex="2"
                // typeOf={1}
                isObjArr={true}
                dataKey={`BranchName`}
                idKey={`BranchID`}
                allValues={receivedState}
                setAllValue={setReceivedState}
              />
            </Item>
          </Grid>
          <Grid item xs={6} md={1}>
            <Item sx={{ background: '#e1f2fe' }}>
              <Button
                variant="contained"
                id="Receivebtn"
                sx={{ width: '100%' }}
                style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                onClick={() => onClick('Search')}
              >
                {cs.search}
              </Button>
            </Item>
          </Grid>

          <Grid item xs={6} md={1}>
            <Item sx={{ background: '#e1f2fe', display: 'flex' }}>
              {filter ? (
                <>
                  <div onClick={() => setState({ ...state, filter: false })} className="morefilterstyle">
                    {' '}
                    {btr.closeFilter}{' '}
                  </div>
                  <ArrowDropUpIcon onClick={() => setState({ ...state, filter: false })} className="receivedItemIcon" />
                </>
              ) : (
                <>
                  <div onClick={() => setState({ ...state, filter: true })} className="morefilterstyle">
                    {' '}
                    {btr.moreFilter}{' '}
                  </div>
                  <ArrowDropDownIcon onClick={() => setState({ ...state, filter: true })} className="receivedItemIcon" />
                </>
              )}
            </Item>
          </Grid>
        </Grid>
        {filter && (
          <Grid container sx={{ background: '#e1f2fe' }}>
            <Grid item xs={6} md={3}>
              <Item sx={{ background: '#e1f2fe' }}>
                <DropDown
                  type={Transfer_Type}
                  data={TransferType || []}
                  width="100%"
                  searchPlaceholder={btr.searchTransferType}
                  label={btr.transferType}
                  tabIndex="2"
                  // typeOf={1}
                  // isObjArr = {true}
                  id={Transfer_Type}
                  crossIconId={'ReceivedTransferType'}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                />
              </Item>
            </Grid>

            <Grid item xs={6} md={3}>
              <Item sx={{ background: '#e1f2fe', display: 'flex', width: '100%' }}>
                <Box style={{ width: '50%', marginRight: '13px' }}>
                  <DropDown
                    type={ReceivedItem_Payment_Type}
                    data={PaymentType || []}
                    width="100%"
                    searchPlaceholder={btr.searchPaymentType}
                    label={cs.paymentType}
                    tabIndex="2"
                    // typeOf={1}
                    // isObjArr = {true}
                    id={ReceivedItem_Payment_Type}
                    crossIconId={'ReceivedPaymentType'}
                    allValues={receivedState}
                    setAllValue={setReceivedState}
                  />
                </Box>
                <Box style={{ width: '50%', marginLeft: '3px' }}>
                  <DropDown
                    type={ReceivedItem_Consignment_Type}
                    data={ItemType || []}
                    width="100%"
                    searchPlaceholder={btr.searchConsignmentType}
                    label={cs.consignmentType}
                    tabIndex="2"
                    // typeOf={1}
                    // isObjArr = {true}
                    id={ReceivedItem_Consignment_Type}
                    crossIconId={'ReceivedConsignmentType'}
                    allValues={receivedState}
                    setAllValue={setReceivedState}
                  />
                </Box>
              </Item>
            </Grid>
            <Grid item xs={6} md={2}>
              <Item sx={{ background: '#e1f2fe' }}>
                <DropDown
                  type={ReceivedItem_vehicleNo}
                  data={VehicleNo || []}
                  width="100%"
                  searchPlaceholder={btr.searchVehicleNumber}
                  label={cs.vehicleNo}
                  tabIndex="2"
                  // typeOf={1}
                  // isObjArr = {true}
                  id={ReceivedItem_vehicleNo}
                  crossIconId={'ReceivedVehicleNo'}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                />
              </Item>
            </Grid>
            <Grid item xs={6} md={2}>
              <Item sx={{ background: '#e1f2fe' }}>
                <DropDown
                  type={ReceivedItem_ChallanNo}
                  data={VoucherNo || []}
                  width="100%"
                  searchPlaceholder={btr.searchChallanNo}
                  label={btr.challanNo}
                  tabIndex="2"
                  // typeOf={1}
                  // isObjArr = {true}
                  id={ReceivedItem_ChallanNo}
                  crossIconId={'ReceivedChallanNo'}
                  allValues={receivedState}
                  setAllValue={setReceivedState}
                />
              </Item>
            </Grid>
            <Grid item xs={6} md={1}>
              <Item sx={{ background: '#e1f2fe' }}>
                <Button
                  variant="contained"
                  id="Receivebtn"
                  sx={{ width: '100%' }}
                  style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                  //   onKeyDown={(e) => onKeyDown('Receivebtn', e)}
                    onClick={() => onClick('Filterbtn')}
                >
                  {' '}
                  {cs.filter}
                </Button>
              </Item>
            </Grid>
            <Grid item xs={6} md={1} className="itemButtons">
              <Item sx={{ background: '#e1f2fe' }}>
                <Button variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => onClick('ResetBTN')}>
                  {' '}
                  {cs.reset}
                </Button>
              </Item>
            </Grid>
          </Grid>
        )}
        {buttonsShow && (
          <>
            {load ? (
              <Grid container className="itemButtons">
                <Grid item xs={6} md={11}></Grid>
                <Grid item xs={6} md={1}>
                  <Item>
                    <Button
                      variant="outlined"
                      sx={{ width: '100%' }}
                      //   style={{ borderColor: '#ff0000', color: '#ff0000', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                      className="receiveitembtn"
                      onClick={() => onClick('Back')}
                    >
                      {cs.back}
                    </Button>
                  </Item>
                </Grid>
              </Grid>
            ) : (
              <Grid container className="itemButtons">
                <Grid item xs={6} md={6}></Grid>

                <Grid item xs={6} md={2}>
                  <Item>
                    <ReactHtmlTableToExcel
                      id="test-table-xls-button"
                      className="receiveitemExcelBtn"
                      table="table-to-xls"
                      filename="Branch Received Item List"
                      sheet="tablexls"
                      buttonText={btr.exportToExcel}
                    />
                  </Item>
                </Grid>
                <Grid item xs={6} md={2}>
                  <Item>
                    <Button variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => onClick('ExportPDF')}>
                      {cs.exportToPdf}
                    </Button>
                  </Item>
                </Grid>
                <Grid item xs={6} md={2}>
                  <Item>
                    <Button
                      variant="outlined"
                      sx={{ width: '100%' }}
                      //   style={{ borderColor: '#ff0000', color: '#ff0000', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                      className="receiveitembtn"
                      onClick={() => onClick('PrintPDF')}
                    >
                      {cs.print}
                    </Button>
                  </Item>
                </Grid>
              </Grid>
            )}
          </>
        )}
        {searchResult ? (
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 350 }}>
            <TableContainer className="lr-popup-table lrModel">
              <Table style={{}} id="table-to-xls" className="table1 table-Received" size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                  <TableRow style={{ background: '#d5ecfe', color: 'black' }}>
                    <TableCell className="ReceivedItemHead">{btr.srNo}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.lrNoManualLrNo}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.transferFromDate}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.receivedDate}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.senderName}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.receiverName}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.transferByBranch}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.receivedByBranch}</TableCell>
                    <TableCell className="ReceivedItemHead">{cs.vehicleNo}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.challanNo}</TableCell>
                    <TableCell className="ReceivedItemHead">{cs.paymentType}</TableCell>
                    <TableCell className="ReceivedItemHead">{cs.consignmentType}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.units}</TableCell>
                    <TableCell className="ReceivedItemHead">{btr.grossAmount}</TableCell>
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={14}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>{cs.noResultsFound}</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData.length > 1 ? (
                  <TableBody className="filter-data-row">
                    {tableData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        ) : (
          <>
            {generatePDF ? <div className={'generatePDF'}>{cs.pdfGenerationMsg}</div> : ''}
            {load ? (
              <object
                id="output"
                type="application/pdf"
                width="1388"
                height="440"
                title="MTLPL -Cargo System - After Transfer Summary Report"
                aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              ></object>
            ) : (
              ''
            )}
          </>
        )}
      </Stack>

    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  getBranchList,
  updateBrnchList,
  updateStrtBrnch,
  getUpdateReceiveItemList,
  updateAlert,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceivedItem)
